import sample_1 from './sample1.jpeg';

export const esdImageImpressions = {
    sample_1,
};
